import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import * as VueGoogleMaps from "vue2-google-maps";
import { googleMapKey } from "./common/constant";
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import './common/style.css';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vueResource from 'vue-resource'

Vue.use(Vuetify)
Vue.use(BootstrapVue)
Vue.use(vueResource)
Vue.use(VueGoogleMaps, {
  load: {
    key: googleMapKey,
    libraries: "places" // necessary for places input
  }
});
Vue.component('GmapCluster', GmapCluster)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
